function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { Radio } from "..";
export const RadioBoxLabel = styled.label`
  background-color: ${props => props.checked ? props.theme.colors.actionLight : props.theme.colors.white};
  border: ${props => props.checked ? "2px" : "1px"} solid
    ${props => props.checked ? props.theme.colors.action : props.theme.colors.border};
  border-radius: 4px;
  box-sizing: border-box;
  display: block;
  padding: 6px 8px;
  margin-bottom: 8px;
  margin-right: 8px;
  width: 80px;
  cursor: pointer;
  text-align: center;

  &[disabled] {
    cursor: default;
    background-color: ${props => props.theme.colors.checkboxDisabledUncheckedFill};
    border-color: ${props => props.theme.colors.checkboxDisabledPath};
  }
`;
export const RadioBox = ({
  children,
  title,
  icon,
  checked,
  disabled,
  ...props
}) => {
  return React.createElement(RadioBoxLabel, {
    disabled: !!disabled,
    checked: !!checked
  }, React.createElement(Radio, _extends({
    title: title,
    checked: checked,
    disabled: disabled,
    hideCircle: true,
    icon: icon
  }, props), children));
};